import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ProductCarouselComponent } from '@sdvor/product/ui/v2';
import { UrlModule } from '@spartacus/core';

@Component({
  selector: 'sd-cart-empty',
  imports: [RouterLink, UrlModule, ProductCarouselComponent],
  templateUrl: './cart-empty.component.html',
  styleUrls: ['./cart-empty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartEmptyComponent {}
